export class FilterRequestEvaluated {
  evaluador: String;
  fechaInicial: Date;
  fechaFinal: Date;
  institucion: String;
  programa: String;
  materia: String;
  cedula: String;
  tipo: String;
}
